'Use strict';

class VouchersController {
    /* @ngInject */
    constructor(
        VouchersService,
        OrderTranslationService,
        WorkersService,
        EmployeesService,
        $scope
    ) {
        Object.assign(this, {
            VouchersService,
            OrderTranslationService,
            WorkersService,
            EmployeesService,
            $scope
        });

        this.query = {
            getAll: true,
            include: [
                'worker',
                'employee',
                'assignedEmployee'
            ],
            where: {},
            limit: 10,
            page: 1,
            order: 'createdAt DESC',
            deleted: true
        };

        this.getModels();

        this.onPagination = () => {
            this.getModels();
        };

        this.onReorder = () => {
            this.getModels();
        };
    }

    afterFirstSave() {
        this.neverEditable = true;
    }

    getModels() {
        let qOpts = JSON.parse(JSON.stringify(this.query));

        if (this.worker) {
            Object.assign(qOpts.where, {
                workerId: this.worker.id
            });
        }
        if (this.assignedEmployee) {
            Object.assign(qOpts.where, {
                assignedEmployeeId: this.assignedEmployee.id
            });
        }

        if (this.onlyNonAssociated) {
            Object.assign(qOpts.where, {
                spendingsAmount: 0
            });
        }
        if (this.mdOrder) {
            qOpts.order = this.OrderTranslationService.translate(
                this.mdOrder
            );
        }
        return this.VouchersService
            .getModels(qOpts)
            .then(res => {
                console.debug(res);
                this.vouchers = res.result.vouchers;
                this.vouchersCount = res.result.count;
            });
    }

    queryWorkerSearch() {
        return this.WorkersService.find({
            filter: {
                where: {
                    name: {
                        regexp: `^${this.searchWorkerText}/i`
                    }
                }
            }
        });
    }

    queryEmployeeSearch() {
        return this.EmployeesService.find({
            filter: {
                where: {
                    name: {
                        regexp: `^${this.searchEmployeeText}/i`
                    }
                }
            }
        });
    }
}

export default VouchersController;
